import { Suspense } from "react";
import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";
import { DialogErrorV2 } from "@components/ui_v2/DialogErrorV2";

const OnboardingPageLayout = () => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100vh", bgcolor: "background.paper" }}>
      <Box sx={{ flex: 1, minHeight: 0, display: "flex" }}>
        <Suspense fallback={<></>}>
          <Outlet />
        </Suspense>
      </Box>
      {/* Modal de error v2 (`app.modal_error`); el legacy solo vive en `MainLayout`. */}
      <DialogErrorV2 />
    </Box>
  );
};

export default OnboardingPageLayout;
